/**
 * Constants used by bubbles
 */
export default class TalkConfig {
  static enterScreenTrigger = "enter-screen";
  static playerCloseTrigger = "player-close";
}
